export default __webpack_public_path__ + "static/media/portgo-mobile-1.275db158.png";